import { Box, Dialog, Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { ButtonCustom } from '../Button/ButtonCustom'

type CustomDialogProps = {
  type?: 'negative' | 'neutral'
  title: string
  description?: string
  primaryButtonText: string
  secondaryButtonText?: string
  open: boolean
  onClose?: () => void
  additionalJSX?: any
  onPrimaryButtonClick?: () => void
  onSecondaryButtonClick?: () => void
  disablePrimaryButton?: boolean
}

export const CustomDialog = ({
  type = 'negative',
  title,
  description,
  primaryButtonText,
  secondaryButtonText,
  open,
  onClose,
  additionalJSX,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  disablePrimaryButton
}: CustomDialogProps) => {
  const iconBackground =
    type === 'negative' ? 'rgba(255, 144, 110, 0.4)' : 'rgba(255, 215, 72, 0.4)'
  const iconColor = type === 'negative' ? '#FF5722' : '#FB8C00'

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ '.MuiDialog-paper': { borderRadius: 3 } }}
    >
      <Box sx={{ width: { sm: 468 }, px: 3, py: 4 }}>
        <Box
          sx={{
            alignItems: description ? 'flex-start' : 'center',
            display: 'flex'
          }}
        >
          <Box
            sx={{
              height: 'fit-content',
              alignItems: 'center',
              bgcolor: iconBackground,
              borderRadius: 2,
              display: 'flex',
              justifyContent: 'center',
              p: 1
            }}
          >
            <ErrorOutlineIcon sx={{ color: iconColor, fontSize: 20 }} />
          </Box>

          <Box sx={{ ml: 2 }}>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 700,
                letterSpacing: 0.1,
                lineHeight: 1
              }}
            >
              {title}
            </Typography>
            {description && (
              <Typography
                sx={{
                  color: '#333',
                  letterSpacing: 0.1,
                  lineHeight: 1.4,
                  mt: 1
                }}
              >
                {description}
              </Typography>
            )}
          </Box>
        </Box>

        {additionalJSX}

        <ButtonCustom
          icon={false}
          backgroundColor='#333'
          color='#fff'
          label={primaryButtonText}
          disabled={disablePrimaryButton}
          onClick={onPrimaryButtonClick}
          width='100%'
          sx={{
            height: 40,
            m: 0,
            mt: 2,
            textTransform: 'none'
          }}
        />

        {secondaryButtonText && (
          <ButtonCustom
            variant='outlined'
            icon={false}
            label={secondaryButtonText}
            onClick={onSecondaryButtonClick}
            width='100%'
            sx={{
              height: 40,
              borderColor: '#333',
              m: 0,
              mt: 2,
              textTransform: 'none'
            }}
          />
        )}
      </Box>
    </Dialog>
  )
}
